<template>
  <div>
    <v-card width="6000">
      <v-card-title>
        <DialogTitle :dialogName="$options.name">
          Service Types
        </DialogTitle>
      </v-card-title>
      <v-card-text>
        <v-data-table
          dense
          :items-per-page="10"
          :footer-props="{
            'show-first-last-page': true
          }"
          :headers="headers"
          :items="infoList"
          :loading="loading"
          class="elevation-1"
        >
          <template v-slot:item.IconName="{ item }">
            <v-icon :color="feature.services.color">
              {{ item.IconName }}
            </v-icon>
          </template>
          <template v-slot:item.IsDeleted="{ item }">
            <v-icon v-if="item.IsDeleted" color="error">
              {{ icon.lineItemIsDeleted }}
            </v-icon>
          </template>
          <template v-slot:item.IsAutoCloseService="{ item }">
            <v-icon v-if="item.IsAutoCloseService" color="success">
              {{ icon.checkMark }}
            </v-icon>
          </template>
          <template v-slot:item.IsExemptRequiredMeasures="{ item }">
            <v-icon v-if="item.IsExemptRequiredMeasures" color="success">
              {{ icon.checkMark }}
            </v-icon>
          </template>
          <template v-slot:item.Actions="{ item }">
            <v-icon small class="mr-2" @click="editItemClick(item)">
              {{ icon.lineItemEdit }}
            </v-icon>
            <v-icon small @click="deleteItemClick(item)">
              {{ icon.lineItemDelete }}
            </v-icon>
          </template>
        </v-data-table>
        <div class="table-footer-prepend d-flex pl-2 align-center">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on" @click="newItemClick">
                <v-icon>{{ icon.lineItemAdd }}</v-icon>
              </v-btn>
            </template>
            <span>New Service Type</span>
          </v-tooltip>
        </div>
      </v-card-text>
    </v-card>

    <v-dialog v-model="showEditorDialog" width="845" persistent>
      <ServiceTypeEditor
        :infoId="selectedItemId"
        :isDialogOpen="showEditorDialog"
        @close="editorCloseEvent"
        @update="editorUpdateEvent"
      />
    </v-dialog>
    <DialogUtil ref="dialogUtil" />
  </div>
</template>
<script>
import { ref, watch } from 'vue'
import { icon, feature } from '@/use/Constants'
import { host } from '@/services/HostAPI'
import { selectListCache } from '@/services/SelectListCache'
import ServiceTypeEditor from '@/components/Setup/Service/ServiceTypeEditor'
export default {
  name: 'ServiceTypeList',
  props: {
    isDialogOpen: {
      type: Boolean,
      default: false
    }
  },
  components: { ServiceTypeEditor },
  setup(props) {
    const dialogUtil = ref(null)
    const loading = ref(false)

    watch(
      () => props.isDialogOpen,
      newVal => {
        newVal && initDialog()
      }
    )

    const initDialog = () => {
      infoList.value = []
      getServiceTypeList()
    }

    const infoList = ref([])
    const selectedItemId = ref(null)
    const showEditorDialog = ref(false)

    const getServiceTypeList = async () => {
      loading.value = true
      const rq = {}
      const rs = await host.serviceType.list(rq)
      infoList.value = rs.InfoList
      loading.value = false
    }

    function editItemClick(item) {
      selectedItemId.value = item.ServiceTypeId
      showEditorDialog.value = true
    }

    function deleteItemClick(item) {
      dialogUtil.value
        .confirm({
          title: 'Please confirm',
          text: `Delete Service Type ${item.Code}`
        })
        .then(() => performDeleteServiceType(item))
        .catch(() => {
          return
        })
    }

    async function performDeleteServiceType(item) {
      const rq = { InfoId: item.ServiceTypeId }
      const rs = await host.serviceType.delete(rq)
      if (rs.IsSuccess) {
        selectListCache.invalidate(selectListCache.name.ServiceTypes)
        getServiceTypeList()
      } else {
        dialogUtil.value.error(rs.Message)
      }
    }

    function newItemClick() {
      selectedItemId.value = null
      showEditorDialog.value = true
    }

    const headers = [
      { value: 'IconName', text: 'Icon' },
      { value: 'Code', text: 'Code' },
      { value: 'Description', text: 'Description' },
      {
        value: 'IsAutoCloseService',
        text: 'Auto Close Service'
      },
      {
        value: 'IsExemptRequiredMeasures',
        text: 'Exempt Required Measures'
      },
      { value: 'IsDeleted', text: 'Deleted', align: 'center' },
      { value: 'Actions', text: 'Actions', sortable: false, width: 60 }
    ]

    const editorCloseEvent = () => {
      showEditorDialog.value = false
    }

    const editorUpdateEvent = () => {
      showEditorDialog.value = false
      getServiceTypeList()
    }

    initDialog()

    return {
      dialogUtil,
      infoList,
      headers,
      showEditorDialog,
      selectedItemId,
      editItemClick,
      deleteItemClick,
      newItemClick,
      editorCloseEvent,
      editorUpdateEvent,
      feature,
      icon,
      loading
    }
  }
}
</script>

<style lang="scss" scoped></style>
